import { useLang } from "../lib/i18n";

export const Footer = () => {
  const { c } = useLang();
  return (
  <footer className="bg-[#2C3552] text-[#FAFAF1] py-20 px-6 border-t border-[#FAFAF1]/10" data-testid="footer">
    <div className="max-w-5xl mx-auto text-center">
      <p className="font-serif-display font-light text-5xl sm:text-6xl">
        P <span className="italic text-[#F4B8C6]">&amp;</span> L
      </p>
      <p className="mt-5 font-serif-display text-xl sm:text-2xl font-light text-[#FAFAF1]/80" data-testid="footer-full-names">
        Diana Paulina &amp; Anthony Louie
      </p>
      <p className="mt-4 text-[11px] uppercase tracking-[0.4em] text-[#FAFAF1]/50">{c.hero.dateline}</p>
      <p className="mt-10 font-serif-display italic text-lg text-[#FAFAF1]/40">{c.footer.quote}</p>
    </div>
  </footer>
  );
};
